import { render, staticRenderFns } from "./phone-dialog.vue?vue&type=template&id=2c1aec3a"
import script from "./phone-dialog.vue?vue&type=script&lang=js"
export * from "./phone-dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports